import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=7fffb1aa&scoped=true&"
import script from "./PopupLayout.vue?vue&type=script&lang=ts&"
export * from "./PopupLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PopupLayout.vue?vue&type=style&index=0&id=7fffb1aa&lang=less&scoped=true&"
import style1 from "./PopupLayout.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffb1aa",
  null
  
)

export default component.exports